import { Spinner } from "react-bootstrap";
import logo from '../../resize_logo.png';

export const PageLoader = () => (
  <div className="full-page-loader">
    <img src={logo} alt="SevenData Logo"/>
    <Spinner animation="border" variant="primary"/>
  </div>
);